import { DataSource } from '@angular/cdk/collections';
import { MatSort } from '@angular/material/sort';
import {debounceTime, distinctUntilChanged, filter, map, startWith, tap} from 'rxjs/operators';
import {BehaviorSubject, combineLatest, from, Observable, of, ReplaySubject, switchMap} from 'rxjs';
import { FormControl } from '@angular/forms';
import { FilterTypes } from '../../../services/default-filter.service';
import {
    IFilterTypeSearchMultiSelectValue,
    IFilterTypeTimespanValue,
} from '../../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import {
    LedgerImportDocumentTypeNames,
    LedgerImportDocumentTypes,
    LedgerImportEntity,
    LedgerImportStatusNames,
} from '../../../dave-data-module/entities/ledger-import.entity';
import { PartnerOfficeAdditionalData } from '../../../dave-data-module/entities/partnerOffice.entity';
import { compareEqualityAsJsonString, isNotNullOrUndefined, SearchQueriesDebounceTime } from '../../../helper/helper';
import { getCustomers } from '../../../dave-data-module/State/selectors/customers.selectors';
import { getOwnPartnerOffices } from '../../../dave-data-module/State/selectors/partners.selectors';
import { CurrencyPipe, DatePipe, formatDate } from '@angular/common';
import { Store } from '@ngrx/store';
import { State } from '../../../dave-data-module/State';
import { MatLegacyPaginator } from '@angular/material/legacy-paginator';
import {
    LedgerImportDataService
} from "../../../dave-data-module/services/ledger-import-data.service";
import {inject} from "@angular/core";
import {LedgerImportSortEnum, SortDirectionEnum} from "@dave/types/dist/proto/accounting/ledgerImport";
import {LedgerImportTableData} from "../select-ledger-import-dialog/select-ledger-import-dialog.component";

export interface LedgerImportTableItem {
    Id: number;
    CustomerNumber: string;
    CustomerName: string;
    InvoiceNumber: string;
    // InvoiceNumberForSorting: number;
    Type: string;
    createdAt: Date;
    updatedAt: Date;
    CreatedAt: string;
    UpdatedAt: string;
    id: number;
    Status: string;
    ConsolidatedAmount: string;
    ConsolidatedAmountAsNumber: number;
    ConsolidatedWithoutTax: string;
    ConsolidatedWithoutTaxAsNumber: number;
    DueDate: string;
    dueDate: Date;
    Notes: string;
    Title: string;
    UserId: number;
    CommissionId: number;
    CustomerId: number;
    type: LedgerImportDocumentTypes;
    ConsolidatedDate: string;
    consolidatedDate: Date;
    consolidatedDateInMS: number;


    DocumentType: LedgerImportDocumentTypes;
    ConsolidatedInvoiceId: string;
    partnerOfficeAdditionalData: PartnerOfficeAdditionalData;
}


export interface LiFilterValues {
    [FilterTypes.Customers]: IFilterTypeSearchMultiSelectValue<number>[];
    [FilterTypes.Status]: IFilterTypeSearchMultiSelectValue<string>[];
    [FilterTypes.Type]: IFilterTypeSearchMultiSelectValue<LedgerImportDocumentTypes>[];
    [FilterTypes.AssignedUser]: IFilterTypeSearchMultiSelectValue<number>[];
    [FilterTypes.AssignedCommission]: IFilterTypeSearchMultiSelectValue<number>[];
    [FilterTypes.Date]: IFilterTypeTimespanValue;
}

/**
 * Data source for the LedgerImportTable view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class LedgerImportTableDataSource extends DataSource<LedgerImportTableItem> {
    searchForm = new FormControl<string>('');
    filterValues$: BehaviorSubject<LiFilterValues>;
    private lasySort$ = new ReplaySubject<MatSort>(1);
    private lasyPaginator$ = new ReplaySubject<MatLegacyPaginator>(1);


    // data: LedgerImportTableItem[] = EXAMPLE_DATA;
    // paginator: MatLegacyPaginator | undefined;
    // sort: MatSort | undefined;

    data$: Observable<LedgerImportTableItem[]>;
    protected ledgerImportDataService: LedgerImportDataService = inject(LedgerImportDataService);

    constructor(
        protected store: Store<State>,
        protected currencyPipe: CurrencyPipe,
        protected datePipe: DatePipe,
        protected locale: string,
        ) {
        super();
        // this.data$ = combineLatest([
        //     store.select(getLedgerImports).pipe(filter(isNotNullOrUndefined)),
        //     store.select(getCustomers),
        //     store.select(getOwnPartnerOffices),
        // ]).pipe(
        //     map(([li, customers, partneroffices]) => {
        //         return li
        //             .sort((a, b) => a.ConsolidatedDate?.getTime() - b.ConsolidatedDate?.getTime())
        //             .map<LedgerImportTableItem>((invoice) => ({
        //                 Id: invoice.Id,
        //                 CustomerNumber: customers.find((c) => invoice.CustomerId === c.Id)?.CustomerNo,
        //                 CustomerName: invoice.CustomerName,
        //                 Type:
        //                     invoice.DocumentType === LedgerImportDocumentTypes.PartialInvoice
        //                         ? invoice.PartialInvoiceCounter + '. ' + LedgerImportDocumentTypeNames.get(invoice.DocumentType)
        //                         : LedgerImportDocumentTypeNames.get(invoice.DocumentType),
        //                 type: invoice.DocumentType,
        //                 createdAt: invoice.CreatedAt,
        //                 updatedAt: invoice.UpdatedAt,
        //                 CreatedAt: formatDate(invoice.CreatedAt, 'dd.MM.yyyy', locale),
        //                 UpdatedAt: formatDate(invoice.UpdatedAt, 'dd.MM.yyyy', locale),
        //                 InvoiceNumber: invoice.ConsolidatedInvoiceId ? invoice.ConsolidatedInvoiceId : 'unbenannte ' + LedgerImportDocumentTypeNames.get(invoice.DocumentType) + 'snummer',
        //                 // InvoiceNumberForSorting: LedgerImportEntity.GetRegex(
        //                 //     invoice.ConsolidatedInvoiceId ? invoice.ConsolidatedInvoiceId : null,
        //                 //     partneroffices?.find((p) => p.Id === invoice.PartnerOfficeId)?.AdditionalData,
        //                 //     invoice.DocumentType,
        //                 // ),
        //                 id: invoice.Id,
        //                 Status: LedgerImportStatusNames.get(invoice.Status),
        //                 ConsolidatedAmount: currencyPipe.transform(invoice.ConsolidatedAmount, invoice.ConsolidatedCurrencyCode),
        //                 ConsolidatedAmountAsNumber: invoice.ConsolidatedAmount,
        //                 ConsolidatedWithoutTax: currencyPipe.transform(invoice.ConsolidatedNettoAmount / 100, invoice.ConsolidatedCurrencyCode),
        //                 ConsolidatedWithoutTaxAsNumber: invoice.ConsolidatedNettoAmount,
        //                 DueDate: datePipe.transform(invoice.DueDate),
        //                 dueDate: invoice.DueDate,
        //                 Notes: invoice.AdditionalData?.notes ? invoice.AdditionalData?.notes : '',
        //                 Title: invoice.Title,
        //                 CommissionId: invoice.CommissionId,
        //                 UserId: invoice.UserId,
        //                 CustomerId: invoice.CustomerId,
        //                 ConsolidatedDate: invoice.ConsolidatedDate && datePipe.transform(invoice.ConsolidatedDate),
        //                 consolidatedDate: invoice.ConsolidatedDate,
        //                 consolidatedDateInMS: invoice.ConsolidatedDate?.getTime(),
        //
        //                 ConsolidatedInvoiceId: invoice.ConsolidatedInvoiceId ? invoice.ConsolidatedInvoiceId : null,
        //                 DocumentType: invoice.DocumentType,
        //                 partnerOfficeAdditionalData: partneroffices?.find((p) => p.Id === invoice.PartnerOfficeId)?.AdditionalData,
        //
        //             }));
        //     }));
    }

    setSort(sort: MatSort) {
        this.lasySort$.next(sort);
    }

    setPaginator(paginator: MatLegacyPaginator) {
        this.lasyPaginator$.next(paginator);
    }

    /**
     * Connect this data source to the table. The table will only update when
     * the returned stream emits new items.
     * @returns A stream of the items to be rendered.
     */
    connect(): Observable<LedgerImportTableItem[]> {
        if (this.lasySort$ && this.lasyPaginator$ && this.searchForm && this.filterValues$) {
            // Combine everything that affects the rendered data into one update
            // stream for the data-table to consume.
            // return combineLatest([
            //     this.data$,
            //     this.lasyPaginator$,
            //     this.lasySort$.pipe(switchMap(sort => sort.sortChange.pipe(startWith(null), map(() => sort)))),
            //     this.filterValues$.pipe(distinctUntilChanged(compareEqualityAsJsonString)),
            //     this.searchForm.valueChanges.pipe(debounceTime(SearchQueriesDebounceTime), startWith(null), distinctUntilChanged((a, b) => formatSearchTerm(a) === formatSearchTerm(b))),
            // ])
            //     .pipe(
            //         switchMap(([data, paginator, sort, filterValues, searchFormValue]) => {
            //             paginator.firstPage();
            //             return paginator.page.pipe(
            //                 startWith(null),
            //                 map(() => {
            //                     const filtered = this.getSerchedData(this.getFilteredData([...data]));
            //                     this._filteredDataLength$.next(filtered.length);
            //                     return this.getPagedData(paginator, this.getSortedData(sort, filtered));
            //                 }));
            //         }));
            return combineLatest([
                this.lasyPaginator$,
                this.lasySort$.pipe(switchMap(sort => sort.sortChange.pipe(startWith(null), map(() => sort)))),
                this.filterValues$.pipe(distinctUntilChanged(compareEqualityAsJsonString)),
                this.searchForm.valueChanges.pipe(debounceTime(SearchQueriesDebounceTime), startWith(null), distinctUntilChanged((a, b) => formatSearchTerm(a) === formatSearchTerm(b))),
            ])
                .pipe(
                    switchMap(([paginator, sort, filterValues, searchFormValue]) => {
                        paginator.firstPage();
                        let cache = new Map<number, LedgerImportEntity[]>();
                        let lastId: number|null = null;
                        let lastSortByValue: string|null = null;
                        return paginator.page.pipe(
                            startWith(null),
                            switchMap(() => combineLatest([
                                cache.has(paginator.pageIndex) ?
                                    of(cache.get(paginator.pageIndex)) :
                                    from(this.ledgerImportDataService.getLedgerImportPage(
                                        searchFormValue,
                                        paginator.pageSize,
                                        lastId,
                                        lastSortByValue,
                                        sort.direction == 'asc' ? SortDirectionEnum.ASC : SortDirectionEnum.DESC,
                                        tableSortToBackendSort(sort.active),
                                        filterValues,
                                        // {} as ledgerImportBackendFilter,
                                    )).pipe(
                                        tap((data) => {
                                            cache.set(paginator.pageIndex, data.ledgerImports);
                                            if (isNotNullOrUndefined(data.pageCount)) {
                                                paginator.length = data.pageCount * paginator.pageSize;
                                            }
                                            lastId = data.nextLastId;
                                            lastSortByValue = data.nextSortByValue;
                                        }),
                                        map((data) => data.ledgerImports),
                                    ),
                                this.store.select(getCustomers),
                                this.store.select(getOwnPartnerOffices),
                            ])),
                            map(([ledgerImportsData, customers, partnerOffices]) => ledgerImportsData.map(invoice => ({
                                Id: invoice.Id,
                                CustomerNumber: customers.find((c) => invoice.CustomerId === c.Id)?.CustomerNo,
                                CustomerName: invoice.CustomerName,
                                Type:
                                    invoice.DocumentType === LedgerImportDocumentTypes.PartialInvoice
                                        ? invoice.PartialInvoiceCounter + '. ' + LedgerImportDocumentTypeNames.get(invoice.DocumentType)
                                        : LedgerImportDocumentTypeNames.get(invoice.DocumentType),
                                type: invoice.DocumentType,
                                createdAt: invoice.CreatedAt,
                                updatedAt: invoice.UpdatedAt,
                                CreatedAt: formatDate(invoice.CreatedAt, 'dd.MM.yyyy', this.locale),
                                UpdatedAt: formatDate(invoice.UpdatedAt, 'dd.MM.yyyy', this.locale),
                                InvoiceNumber: invoice.ConsolidatedInvoiceId ? invoice.ConsolidatedInvoiceId : 'unbenannte ' + LedgerImportDocumentTypeNames.get(invoice.DocumentType) + 'snummer',
                                id: invoice.Id,
                                Status: LedgerImportStatusNames.get(invoice.Status),
                                ConsolidatedAmount: this.currencyPipe.transform(invoice.ConsolidatedAmount, invoice.ConsolidatedCurrencyCode),
                                ConsolidatedAmountAsNumber: invoice.ConsolidatedAmount,
                                ConsolidatedWithoutTax: this.currencyPipe.transform(invoice.ConsolidatedNettoAmount / 100, invoice.ConsolidatedCurrencyCode),
                                ConsolidatedWithoutTaxAsNumber: invoice.ConsolidatedNettoAmount,
                                DueDate: this.datePipe.transform(invoice.DueDate),
                                dueDate: invoice.DueDate,
                                Notes: invoice.AdditionalData?.notes ? invoice.AdditionalData?.notes : '',
                                Title: invoice.Title,
                                CommissionId: invoice.CommissionId,
                                UserId: invoice.UserId,
                                CustomerId: invoice.CustomerId,
                                ConsolidatedDate: invoice.ConsolidatedDate && this.datePipe.transform(invoice.ConsolidatedDate),
                                consolidatedDate: invoice.ConsolidatedDate,
                                consolidatedDateInMS: invoice.ConsolidatedDate?.getTime(),

                                ConsolidatedInvoiceId: invoice.ConsolidatedInvoiceId ? invoice.ConsolidatedInvoiceId : null,
                                DocumentType: invoice.DocumentType,
                                partnerOfficeAdditionalData: partnerOffices?.find((p) => p.Id === invoice.PartnerOfficeId)?.AdditionalData,

                            })))
                        );
                    }));
        } else {
            console.log({
                paginator: this.lasyPaginator$,
                sort: this.lasySort$,
                searchForm: this.searchForm,
                filterValues$: this.filterValues$,
            })
            // throw Error('Please set the paginator, searchForm, filterValues$ and sort on the data source before connecting.');
            console.error('Please set the paginator, searchForm, filterValues$ and sort on the data source before connecting.');
            return of([]);
        }
    }

    /**
     *  Called when the table is being destroyed. Use this function, to clean up
     * any open connections or free any held resources that were set up during connect.
     */
    disconnect(): void {
    }
}
function tableSortToBackendSort(key: string) {
    switch (key as keyof LedgerImportTableItem) {
        case "ConsolidatedInvoiceId":
            return LedgerImportSortEnum.ConsolidatedInvoiceId;
        case "Title":
            return LedgerImportSortEnum.Title;
        case "ConsolidatedDate":
            return LedgerImportSortEnum.ConsolidatedDate;
        case "DueDate":
            return LedgerImportSortEnum.DueDate;
        case "CreatedAt":
            return LedgerImportSortEnum.CreatedAt;
        case "UpdatedAt":
            return LedgerImportSortEnum.UpdatedAt;
        case undefined:
            return LedgerImportSortEnum.Nothing;
        default:
            console.error(`Unknown ledgerimport sort: ${key}`);
            return LedgerImportSortEnum.Nothing;
    }
}
function formatSearchTerm(searchTerm: string | null): string {
    return (searchTerm || '').trim().toLowerCase();
}
